import type { FaireProductEntity } from "../../entity_types/product";

export const p_2w6bhbxt97: FaireProductEntity = {
  token: "p_2w6bhbxt97",
  type: "product",
  name: "Long Sleeve Crop Top and Flared Leggings Set",
  brandToken: "b_q6uy7uqavt",
  brandName: "Soli Echo",
  imageUrl:
    "https://cdn.faire.com/fastly/47cb43596ddebae7fd8f730eb4c6b84082a3ade3395f58b62c2719eefd409fbf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/65ed86beeb162285cad2502988ea17ad504105b9f33ce1d3439babe7c5c4d3e4.jpeg",
    "https://cdn.faire.com/fastly/de06d4056e3f076af47ef0b26f96a13d1ab8b948daf7f1f253fe17b9f7ac3010.jpeg",
    "https://cdn.faire.com/fastly/8e2bccc1e7ca1e9797d16f01439441f764747c50e987fdeb8f30a7e65d6bdf43.jpeg",
    "https://cdn.faire.com/fastly/651633430d0a29a6aca8e93c3ecc35ebdd0627a60c0ba69fc409246ba77b3bec.jpeg",
    "https://cdn.faire.com/fastly/bedc5f1055a352091252a5ec2b873a6637004d376abfb51a458a320bc7e50470.jpeg",
    "https://cdn.faire.com/fastly/148b4f206ba164a7f7007bc9a85760aa59781839ef8c4766535d27131b1ece5e.jpeg",
  ],
  priceDollars: 24.68,
  description:
    "Sleek design, curve-enhancing fit—ideal for workouts or casual outings.\n\nFabric: 80%polyamide, 20%elastane\n\nWeight: 0.88 lb\n",
  tags: [],
  msrpDollars: 49.36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:39.278Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
